import React from "react";
import { AddButton } from "components/Topology/interactiveLayer/interectiveElements/AddButton";
import { ZoneTitle } from "components/Topology/interactiveLayer/interectiveElements/ZoneTitle";
import { PastButton } from "components/Topology/interactiveLayer/interectiveElements/PastButton";
import { PastConfigButton } from "components/Topology/interactiveLayer/interectiveElements/PastConfigButton";
import { useWizardActions } from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { useVirtualTopology } from "components/Topology/interactiveLayer/useVirtualTopology";
import { TopologyNode } from "components/Topology/interactiveLayer/interectiveElements/TopologyNode";
import { DropDownMenuControlled } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/DropdownMenuControlled";

export const InteractiveLayer = React.memo(
  ({ layout, viewportRef, transformState }) => {
    const { selectedTopologyItemId } = useWizardActions();

    const visibleElements = useVirtualTopology({
      viewportRef,
      interactiveElementsArr: layout.interactiveElementsArr,
      scale: transformState.scale,
      positionX: transformState.positionX,
      positionY: transformState.positionY,
      padding: { left: 1000, top: 400, right: 200, bottom: 200 },
    });

    return React.useMemo(() => {
      if (!visibleElements?.length) {
        return null;
      }

      return visibleElements.map((btn) => (
        <div
          key={`${btn.startX}-${btn.startY}-${btn.id ?? ""}`}
          style={{
            position: "absolute",
            top: btn.startY,
            left: btn.startX,
            transform:
              btn.interactiveKind !== "node" ? "translateY(-50%)" : "none",
            zIndex: btn.interactiveKind === "node" ? 1 : 2,
          }}
        >
          {btn.interactiveKind === "node" && (
            <TopologyNode
              {...btn}
              isSelected={btn.id === selectedTopologyItemId}
              dropdown={<DropDownMenuControlled {...btn} />}
            />
          )}
          {btn.interactiveKind === "addBtn" && (
            <AddButton
              options={btn.submenu}
              topologyNodeId={btn.topologyNodeId}
              topologyAction={btn.topologyAction}
            />
          )}
          {btn.interactiveKind === "pastBtn" && (
            <PastButton
              topologyParentId={btn.topologyNodeId}
              famGroupIdx={btn.famGroupIdx}
            />
          )}
          {btn.interactiveKind === "pastConfigBtn" && (
            <PastConfigButton
              topologyParentId={btn.topologyNodeId}
              title={btn.title}
              presentation={btn.presentation}
            />
          )}
          {btn.interactiveKind === "zoneBtn" && (
            <ZoneTitle
              isWirelessZone={btn.isWirelessZone}
              title={btn.info}
              zoneId={btn.id}
            />
          )}
        </div>
      ));
    }, [visibleElements, selectedTopologyItemId]);
  },
);
